import { i18n } from "translate/i18n";

export const progress = i18n.t("messages.progress");
